<script setup lang="ts">
import { useWindowScroll } from '@vueuse/core'

defineProps({
  menu: {
    type: Object,
    required: false,
    default: () => ({ menu_items: [] }),
  },
})

const { y } = useWindowScroll()
</script>

<template>
  <!-- top Menu -->
  <div class="absolute top-0 left-0 right-0 z-10 group">
    <div class="group-hover:translate-y-0 -translate-y-16 duration-300 absolute z-10 top-0 left-0 right-0" />
    <div class="relative z-10 mx-auto px-4 lg:px-16 bg-blueproject-clearblue">
      <BlueProjectNavigationMenu :menu="menu" size="lg" />
    </div>
  </div>

  <!-- Fixed Menu -->
  <div class="fixed top-0 left-0 right-0 z-10 duration-300 ease-out bg-blueproject-darkblue" :class="{ '-translate-y-[200px]': y < 500 }">
    <div class="relative z-10 ">
      <BlueProjectNavigationMenu :menu="menu" size="sm" />
    </div>
  </div>
</template>
